// import ViewProduct from "./view_product";
const ViewProduct = React.lazy(() => import ('./view_product.js'));
const CountryProducts = React.lazy(() => import ('../../components/CatalogStore/country_products.js'));
// import CountryProducts from "../../components/CatalogStore/country_products.js";
// const CountryProducts = React.lazy(() => import("../../components/CatalogStore/country_products"));
// import CountryPackages from "./subscription/country_packages.js";
const CountryPackages = React.lazy(() => import("./subscription/country_packages.js"));
import CatalogSpecialPackage from "./subscription/catalog_special_package.js";
import { SubscriptionProvider } from "./catalog_context.js";
import Loading from "../../components/loading.js";

const t0 = performance.now();
function renderCallback(e) {
    console.log("Rendering done", e);
    const t1 = performance.now();

    console.log(`Mount took ~${(t1 - t0) / 1000} seconds.`);
}

class CatalogView extends React.Component {

    render(){
        let renderPage;
        if(window.location.pathname.includes("bundle")){
            renderPage = <React.Fragment>
                <React.Suspense fallback={<Loading />}>
                    <ViewProduct/>
                </React.Suspense>
            </React.Fragment>
        } else {
            renderPage = <React.Fragment>
                <React.Suspense fallback={<Loading />}>
                    <CountryProducts/>
                </React.Suspense>
            </React.Fragment>
        }
        return renderPage;
    }
}
const addonsElContainer = document.querySelector('#country_products_container');
if(addonsElContainer){
    const root = ReactDOM.createRoot(addonsElContainer);
    root.render( <CatalogView />)
}

class CatalogPackage extends React.Component {

    constructor(props) {
        super(props);
        this.handlerRef = React.createRef();
    }

    updateUI(){
        if(this.handlerRef.current){
            this.handlerRef.current.updatePackages();
        }
    }

    render() {
        return(
            <React.Fragment>
                <React.Suspense fallback={<Loading />}>
                    <CountryPackages ref={this.handlerRef}/>
                </React.Suspense>
            </React.Fragment>
        )
    }
}
const packageElContainer = document.querySelector('#country_subscription_container');
if(packageElContainer){
    const root = ReactDOM.createRoot(packageElContainer);
    CountryPackageRender = root.render(<CatalogPackage />);
}

const specialPackageElContainer = document.querySelector('#special_subscription_container');
if(specialPackageElContainer){
    const root = ReactDOM.createRoot(specialPackageElContainer)
    root.render(
        <React.Fragment>
            <React.Suspense fallback={<Loading />}>
                <SubscriptionProvider>
                    <CatalogSpecialPackage />
                </SubscriptionProvider>
            </React.Suspense>
        </React.Fragment>
    )
}
